import axios from 'axios';
import { IChatIa } from 'types/chatIa';
import { api } from './api';

export async function getMessageChatIa(payload: any, token: string): Promise<IChatIa> {
  const { data } = await axios.post(
    `https://api.externo.bb.com.br/assist-joga-junto/v1/acs/llms/agent?gw-dev-app-key=43913df9df470ef7ba6e3825f52d5192`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
    },
  );
  return data;
}

export async function getTokenChatIa(message?: string): Promise<any> {
  const payload: any = {};

  if (typeof message === 'string') {
    payload.message = message;
  }

  const { data } = await api.post(`find/token_chat_ia`, payload);
  return data;
}
